var AnalyticsServiceStub = /** @class */ (function () {
    function AnalyticsServiceStub() {
        this.AppInsights = {
            event: this.eventAppInsights,
        };
    }
    AnalyticsServiceStub.prototype.eventAppInsights = function (name, properties, measurements) {
    };
    return AnalyticsServiceStub;
}());
export { AnalyticsServiceStub };
